module.exports = __webpack_public_path__ + "static/img/homeDispeare.0b588802.png";